import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ConfigService} from '../../services/config/config.service';
import {TableOfContentsComponent} from '../../components/widgets/table-of-contents/table-of-contents.component';
import {TableOfContentsService} from '../../services/toc/table-of-contents.service';
import {GridService} from '../../services/grid/grid.service';
import {DialogComponent} from '../../components/dialog/dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {GoogleAnalyticsService} from '../../services/googleAnalytics/google-analytics.service';

/**
 * Adds the banner to the top of the screen
 */
@Component({
  providers: [TableOfContentsComponent],
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent implements OnInit {
  public bannerLogo: string;
  public logoUrl: string;
  public titleUrl = 'https://dnr.wa.gov';
  public titleText: string;
  public currentRoute = '2d-view';
  public themeList = [];
  public currentTheme = '';
  public appContactInfo;
  public appWebLinks;
  private themeLoadedSubscription;

  constructor(private config: ConfigService, private toc: TableOfContentsService, private title: Title,
    private dialog: MatDialog, private grid: GridService, private ga: GoogleAnalyticsService,
    private cd: ChangeDetectorRef, private tocComponent: TableOfContentsComponent) { }

  ngOnInit() {
    this.bannerLogo = this.config.logoBanner;
    this.logoUrl = this.config.logoUrl;
    this.titleText = this.config.pageTitle;
    this.title.setTitle(this.config.pageTitle);
    this.appContactInfo = this.config.appContactInfo;
    this.appWebLinks = this.config.appWebLinks;
    if (this.config.DNRProgramWebsite) {  // If DNRProgramWebsite specified in config, use that otherwise use default
      this.titleUrl = this.config.DNRProgramWebsite;
    }
    this.cd.detectChanges();
    this.themeList = this.config.themeNameList;
    // When theme data loaded, set the currentTheme and the themeNameList for populating the themename dropdown
    this.themeLoadedSubscription = this.toc.getThemeDataLoaded().subscribe( (themeLoaded) => {
      if (themeLoaded && this.config) {
        this.themeList = this.config.themeNameList;
        this.currentTheme = this.config.CurrentTheme;
        this.cd.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.themeLoadedSubscription) { this.themeLoadedSubscription.unsubscribe()};
  }

  /**
   * Theme clicked, notify the TOC
   * @param themeName
   */
  public async themeClick(themeName) {
    if (themeName) {
      // Refresh toc when theme clicked from banner
      this.grid.widgetOn('toc');
      this.toc.themeClick(themeName);
    }
  }

  /**
   * Page change
   * @param page
   * @param outbound
   */
  public pageChange(page, outbound) {
    if (page === '2d-view' || page === '3d-view') { this.currentRoute = '/' + page; }
    this.ga.eventEmitter('page_view', 'page-change', page);
    this.cd.detectChanges();
  }


  /**
   * Show dialog message
   */
  public showDialog(messageInfo) {
    if (messageInfo) {
      this.dialog.open(DialogComponent, {
        data: messageInfo
      });
    }
    this.cd.detectChanges();
  }

  public async openTocThemes() {
    console.log('openTocThemes');
    // open toc if closed
    await this.grid.widgetOn('toc');
      // this.tocComponent.openThemeMenu();
      console.log(this.toc.themesMenuTrigger);
      setTimeout(() => {
        this.toc.themesMenuTrigger.openMenu();
      }, 0);
  }
}
